import axios from 'axios';

const request = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 12000,
});

request.interceptors.request.use(
  (config) => {
    const access_token = localStorage.getItem('token');
    if (access_token) {
      config.headers.Authorization = 'Bearer ' + access_token;
    }
    return config;
  },

  (error) => errorHandler(error)
);

function errorHandler(error) {
  const response = error?.response;

  if (response) {
    if (response?.status === 403) {
      localStorage.removeItem('token');
      window.location.replace('/login');
    }
    if (response?.status === 401) {
      localStorage.removeItem('token');
      window.location.replace('/login');
    }
  }

  const normalizedError = response
    ? {
        ...response,
        data: response.data || { detail: error?.message || 'Request failed' },
        message: error?.message || response.statusText || 'Request failed',
      }
    : {
        status: 0,
        data: { detail: error?.message || 'Network error' },
        message: error?.message || 'Network error',
        code: error?.code,
      };

  console.error('error => ', normalizedError);

  return Promise.reject(normalizedError);
}

request.interceptors.response.use((response) => response.data, errorHandler);

export default request;
